G.ActionStartBoosters = function(board,am,args) {

	G.Action.call(this,board,am,args);

	this.state = game.state.getCurrentState();

	this.boosters = [];
	this.popCounter = 0;
	this.positions = this.generatePositions();
	this.positionIndex = 0;

	var bubble = null;
	this.delay = 500;
	this.delayIncrease = 200;

  var startBoosters = this.state.startBoosters || [];

	this.normals = this.getTargetCandies();

	this.normalsIndex = 0;

  this.initStartBoosters(startBoosters, args);

  if (G.MYSTERYGIFT && (G.saveState.sessionData.mysteryGift && !G.saveState.sessionData.mysteryGift.mysteryBoostersInitialized)) {
    G.saveState.sessionData.mysteryGift.mysteryBoostersInitialized = true;
    this.initMysteryGifts(G.saveState.mysteryGift_getCurrentGifts());
  }


	this.state.UIFxLayer.addMultiple(this.boosters);

	this.boosters.forEach(function(booster) {
		booster.events.onDestroy.add(function(){
			this.popCounter++;
		},this)
	},this);

};

G.ActionStartBoosters.prototype = Object.create(G.Action.prototype);

G.ActionStartBoosters.prototype.update = function() {

	if (this.popCounter == this.boosters.length) {
		this.finish();
	}

};


G.ActionStartBoosters.prototype.generatePositions = function() {

	var result = [];

	for (var xx = 0.15; xx <= 0.85; xx += 0.14) {
		for (var yy = 0.15; yy <= 0.85; yy += 0.14) {

			result.push([
				xx+game.rnd.realInRange(-0.02,0.02),
				yy+game.rnd.realInRange(-0.02,0.02)
			]);

		}
	}

	return Phaser.ArrayUtils.shuffle(result);

};

/**
 * startBoosters = {
 *  player: Array<Boolean>, //The ones the player bought/given and used
 *  requestHelp: Array<Boolean> //The one retrieved from RequestHelp
 * }
 */
G.ActionStartBoosters.prototype.initStartBoosters = function(startBoosters, passedArgs) {

  let isFirstMove = G.lvl.movesMade == 0;

  let knownGivenBoosters = [];
  if (startBoosters.player) {
    knownGivenBoosters.push(startBoosters.player);
  }
  if (startBoosters.requestHelp) {
    knownGivenBoosters.push(startBoosters.requestHelp);
  }

  // Transaction Tracking
  // Only log boosters 5, 6, 7, and 8, since they are the only ones that are from the inventory
  OMT.transactionTracking.logInventoryTransactionBegin();

  for (let arrayBoosterCounter = 0; arrayBoosterCounter < knownGivenBoosters.length; arrayBoosterCounter++) {
    let currentBoosterSet = knownGivenBoosters[arrayBoosterCounter];
    let isRequestHelpBoosters = arrayBoosterCounter == 1;

    if (currentBoosterSet[5]) {
      const isOutOfMovesBooster = passedArgs.length > 0 && passedArgs[0] === 'outOfMovesIAP';
      var boosterType = isOutOfMovesBooster ? G.gift.GiftContentType.StartBoosterDefaultMovesInstant : G.gift.GiftContentType.StartBoosterDefaultMoves;

  
      G.saveState.useStartBooster(5, isFirstMove, isRequestHelpBoosters);
      var bubble = new G.StartBoosterBubble(
        this.positions[this.positionIndex++],
        G.gift.getIconForType(boosterType),
        this.state.topBar.movesTxt,function() {
          G.lvl.changeMoveNumber(G.gift.getMovesFromBooster(boosterType));
        });
      bubble.goToTarget(this.delay);
      this.delay+=this.delayIncrease;
      this.boosters.push(bubble);

      G.lvl.onPreBoosterUse(5, isOutOfMovesBooster);
      if (!isOutOfMovesBooster) { // don't track if used in out of moves flow
        OMT.transactionTracking.addInventoryChange('boostersUsed', 5, 1);
      }
    }

    if (currentBoosterSet[6]) {
      const isOutOfMovesBooster = passedArgs.length > 0 && passedArgs[0] === 'outOfMovesIAP';
      var boosterType = isOutOfMovesBooster ? G.gift.GiftContentType.StartBoosterSecondaryMovesInstant : G.gift.GiftContentType.StartBoosterSecondaryMoves;
  
      G.saveState.useStartBooster(6, isFirstMove, isRequestHelpBoosters);
      var bubble = new G.StartBoosterBubble(
        this.positions[this.positionIndex++],
        G.gift.getIconForType(boosterType),
        this.state.topBar.movesTxt,
        function() {
          G.lvl.changeMoveNumber(G.gift.getMovesFromBooster(boosterType));
        });
      bubble.goToTarget(this.delay);
      this.delay+=this.delayIncrease;
      this.boosters.push(bubble);

      G.lvl.onPreBoosterUse(6, isOutOfMovesBooster);
      if (!isOutOfMovesBooster) { // don't track if used in out of moves flow
        OMT.transactionTracking.addInventoryChange('boostersUsed', 6, 1);
      }
    }

    // one extra move
    // we know this is from the oom window so less checks are used
    if (currentBoosterSet[10]) {
      const currentBoosterType = G.gift.GiftContentType.StartBooster1MoveInstant;

      G.saveState.useStartBooster(10, isFirstMove, isRequestHelpBoosters);
      const boosterBubble = new G.StartBoosterBubble(
        this.positions[this.positionIndex++],
        G.gift.getIconForType(currentBoosterType),
        this.state.topBar.movesTxt,
        () => {
          G.lvl.changeMoveNumber(G.gift.getMovesFromBooster(currentBoosterType));
        },
      );
      boosterBubble.goToTarget(this.delay);
      this.delay += this.delayIncrease;
      this.boosters.push(boosterBubble);
      // we know its out of moves so we'll just set that here
      G.lvl.onPreBoosterUse(10, true);
    }

    // two extra moves
    // we know this is from the oom window so less checks are used
    if (currentBoosterSet[11]) {
      const currentBoosterType = G.gift.GiftContentType.StartBooster2MovesInstant;

      G.saveState.useStartBooster(11, isFirstMove, isRequestHelpBoosters);
      const boosterBubble = new G.StartBoosterBubble(
        this.positions[this.positionIndex++],
        G.gift.getIconForType(currentBoosterType),
        this.state.topBar.movesTxt,
        () => {
          G.lvl.changeMoveNumber(G.gift.getMovesFromBooster(currentBoosterType));
        },
      );
      boosterBubble.goToTarget(this.delay);
      this.delay += this.delayIncrease;
      this.boosters.push(boosterBubble);
      // we know its out of moves so we'll just set that here
      G.lvl.onPreBoosterUse(11, true);
    }

    if (currentBoosterSet[7]) {
      for (var i = 0; i < 3; i++) {
        if (this.normals[this.normalsIndex+1]) {
          var bubble = new G.StartBoosterBubble(this.positions[this.positionIndex++],'ui_booster_7',this.normals[this.normalsIndex++],function() {
            this.target.changeInto(Math.random()<0.5?'vertical':'horizontal');
          });
          bubble.goToTarget(this.delay);
          this.delay+=this.delayIncrease;
          this.boosters.push(bubble);
        }
      }
      G.saveState.useStartBooster(7, isFirstMove, isRequestHelpBoosters);
      G.lvl.onPreBoosterUse(7);
      OMT.transactionTracking.addInventoryChange('boostersUsed', 7, 1);
    }
  
    if (currentBoosterSet[8]) {
        if (this.normals[this.normalsIndex+1]) {
          G.saveState.useStartBooster(8, isFirstMove, isRequestHelpBoosters);
          var bubble = new G.StartBoosterBubble(this.positions[this.positionIndex++],'ui_booster_8',this.normals[this.normalsIndex++],function() {
            this.target.changeInto('spiral');
          });
          bubble.goToTarget(this.delay);
          this.delay+=this.delayIncrease;
          this.boosters.push(bubble);
          G.lvl.onPreBoosterUse(8);
          OMT.transactionTracking.addInventoryChange('boostersUsed', 8, 1);
        }
    }

    if (currentBoosterSet[3]) {
      this.addChangeIntoBooster("horizontal");
      G.saveState.useStartBooster(3, isFirstMove, isRequestHelpBoosters);
    }

    if (currentBoosterSet[4]) {
      this.addChangeIntoBooster("vertical");
      G.saveState.useStartBooster(4, isFirstMove, isRequestHelpBoosters);
    }

    if (currentBoosterSet[9]) {
      this.addChangeIntoBooster("cross");
      G.saveState.useStartBooster(9, isFirstMove, isRequestHelpBoosters);
    }
  }

  OMT.transactionTracking.logInventoryTransactionEnd();

  if (startBoosters.requestHelp) {
    startBoosters.requestHelp = null; //Empties booster so it cannot be used again
  }
};

G.ActionStartBoosters.prototype.initMysteryGifts = function(mysteryGifts) {

  // we disabled tracking of mystery gift boosters
  /*
  if(gifts.length > 0) {
    DDNA.transactionHelper.trackRewards(gifts, [], {
      transactionType:"REWARD", tActionType:"REWARD", tGameArea:"LEVEL"
    }); 
  }
  */
  
  // add the boosters
  mysteryGifts.forEach(this.addChangeIntoBooster, this);
};

G.ActionStartBoosters.prototype.addChangeIntoBooster = function(giftType) {

  var iconMap = {
    cross: "ui_booster_9",
    vertical: "ui_booster_4",
    spiral: "ui_booster_8",
    horizontal: "ui_booster_3"
  }

  var gemTarget = this.normals[this.normalsIndex+1];

  if (gemTarget) {
     var icon = iconMap[giftType].replace("%%", gemTarget.frameName);
     var bubble = new G.StartBoosterBubble(this.positions[this.positionIndex],
      icon,gemTarget,function() {
      this.target.changeInto(giftType);
    });
    this.normalsIndex++;
    this.positionIndex++;
    bubble.goToTarget(this.delay);
    this.delay+=this.delayIncrease;
    this.boosters.push(bubble);
  }
};

G.ActionStartBoosters.prototype.getTargetCandies = function() {
  var normals = this.board.boardCandies.getNormalCandies()
    .filter(function(candy) {
      return !G.lvl.isGoal(candy.getBaseTypeSymbol());
    });

  Phaser.ArrayUtils.shuffle(normals);

  var filtered = [];
  var neighbours = [];

  normals.forEach(function(g) {
    var isNeighbour = filtered.find(function(elem) {
      return this.board.boardCandies.areCandiesNeighbours(g, elem);
    }, this);

    if (isNeighbour) {
      neighbours.push(g);
    } else {
      filtered.push(g);
    }
  }, this);
  
  return filtered.concat(neighbours);
};